// extracted by mini-css-extract-plugin
module.exports = {"CursorPagination":"CursorPagination_CursorPagination__1kkIH","Page":"CursorPagination_Page__3IK6Q","Button":"CursorPagination_Button__36ZVl"};